var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotPublished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524 524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 30px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n        stroke: #9362c7;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 25px;\n      }\n\n      .cls-3 {\n        stroke-width: 20px;\n      }\n\n      .cls-4 {\n        stroke-width: 13px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.1,395.77h-109.66c-18.17,0-32.97-14.61-33.2-32.78l-3.11-242.95c-.24-19.05,15.13-34.62,34.18-34.62h176.68c20.86,0,37.78,16.91,37.78,37.78v95.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.85,
    y1: 147.49,
    x2: 222.39,
    y2: 147.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.85,
    y1: 208.77,
    x2: 298.78,
    y2: 208.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.85,
    y1: 276.41,
    x2: 232.73,
    y2: 276.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 361.54,
    cy: 349.52,
    r: 90.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_8",
    "data-name": "Capa 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.34,336.35s49.59,68.13,108.4,.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 361.54,
    y1: 383,
    x2: 361.54,
    y2: 398.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 394,
    y1: 375.66,
    x2: 397.18,
    y2: 383.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 328.55,
    y1: 375.66,
    x2: 324.26,
    y2: 382.99
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPublished);
export default __webpack_public_path__ + "static/media/notPublished.8d978bba51aaf2ff8989371875b29882.svg";
export { ForwardRef as ReactComponent };